type AemItemsMap<T> = Readonly<Record<string, T>>;

export const AemItemsKey = ':items' as const;
export const AemOrderKey = ':itemsOrder' as const;

export interface ExperienceFragmentTextItem {
  id: string;
  text: string;
}

export interface ExperienceFragmentRootContent {
  [AemOrderKey]: string[];
  [AemItemsKey]: AemItemsMap<ExperienceFragmentTextItem>;
  columnClassNames?: Record<string, string>;
  gridClassNames?: string;
  columnCount?: number;
}

export interface ExperienceFragmentItems {
  root: ExperienceFragmentRootContent;
}

export interface ExperienceFragmentResponse {
  title: string;
  templateType: string;
  [AemOrderKey]: string[];
  [AemItemsKey]: ExperienceFragmentItems;
}
